/* global RequestInit */
import React, { useState } from 'react';
import { t } from 'i18next';
import DataGridWrapper from '@/core/wrappers/data-grid-wrapper';
import { accountRetailerService } from '@/projects/platform/services/account-retailer-service';
import { createCustomStore } from '@/core/wrappers/custom-store-wrapper';

const App = () => {

  const store = createCustomStore({
    key: ["id"],
    load: accountRetailerService.getLocations,
    insert: accountRetailerService.createLocation,
    update: accountRetailerService.updateLocation,
    remove: accountRetailerService.deleteLocation,
    byKey: (key, loadOptions) => {
      if (key) {
        loadOptions.filter = ["Id", "=", key];
      }
    },
  });

  const [locationTypeStore] = useState(() => createCustomStore({
    key: 'id',
    load: accountRetailerService.lookupLocationTypes,
    byKey:(key, loadOptions) => {
      if (key) {
        loadOptions.filter = ["Id", "=", key];
      }
    },
  }));


  const [regionStore] = useState(() => createCustomStore({
    key: 'id',
    load: accountRetailerService.getRegions,
    byKey: (key, loadOptions) => {
      if (key) {
        loadOptions.filter = ["Id", "=", key];
      }
    },
  }));

  const [cityStore] = useState(() => createCustomStore({
    key: 'id',
    load: accountRetailerService.getCities,
    byKey: (key, loadOptions) => {
      let returnObject = null;
      if (key) {
        loadOptions.filter = ["Id", "=", key];
      }
      return returnObject
    },
  }));

  const handleRowUpdating = async (e: any) => {
    e.newData = { ...e.oldData, ...e.newData }
  };

  return (

    <React.Fragment>
      <DataGridWrapper
        datasource={store}
        permissonCode='Retailer.Location'
        onRowUpdating={handleRowUpdating}
        pagerVisible={true}
        filterVisible={true}
        headerFilterVisible={true}
        props={{ id: "location-list-grid" }}
        enableCustomToolbarContent={false}
        searchPanelVisible={true}
        columnChooser={false}
        columns={[
          {
            dataField: "locationName",
            caption: t("location_name"),
            required: true,
            requiredMessage: t("location_name_is_required")
          },
          {
            dataField: "locationCode",
            caption: t("location_code"),
            required: true,
            requiredMessage: t("location_code_is_required")
          },
          {
            dataField: "parameterLocationTypeId",
            caption: t("location_type"),
            required: true,
            requiredMessage: t("location_type_is_required"),
            lookup: {
              dataSource: locationTypeStore,
              valueExpr: "id",
              displayExpr: "description"
            }
          },
          {
            dataField: "regionId",
            caption: t("region"),
            lookup: {
              dataSource: regionStore,
              valueExpr: "id",
              displayExpr: "name"
            }
          },
          {
            dataField: "accountCityId",
            caption: t("city"),
            lookup: {
              dataSource: cityStore,
              valueExpr: "id",
              displayExpr: "name"
            }
          },
        ]}

      />
    </React.Fragment>
  );
};

export default App;
